import { render } from "./PhotoInput.vue?vue&type=template&id=68867dd2&scoped=true"
import script from "./PhotoInput.vue?vue&type=script&lang=js"
export * from "./PhotoInput.vue?vue&type=script&lang=js"

import "./photo-input.scss?vue&type=style&index=0&id=68867dd2&lang=scss&scoped=true"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68867dd2"]])

export default __exports__